export enum IDTypes {
    Passport = 1,
    IDCard = 2,
    CRN = 3
}